import { navigate } from "wouter/use-browser-location";

import { APP_PATHS } from "@shared/platform/app-metadata";
import { hasControlCharacter } from "@shared/values/control-characters";

export const RETURN_TO_PARAM = "returnTo";

const APP_PATH_PATTERN = /^\/(?![/\\])/;
const SAME_SITE_PROBE_ORIGIN = "https://return-to.invalid";

function staysOnSite(value: string): boolean {
  return new URL(value, SAME_SITE_PROBE_ORIGIN).origin === SAME_SITE_PROBE_ORIGIN;
}

function isAppPath(value: string): boolean {
  return APP_PATH_PATTERN.test(value) && !hasControlCharacter(value) && staysOnSite(value);
}

export function safeReturnPath(value: string | null): string | null {
  return value && isAppPath(value) ? value : null;
}

export function withReturnTo(href: string, returnPath: string): string {
  const separator = href.includes("?") ? "&" : "?";
  return `${href}${separator}${new URLSearchParams({ [RETURN_TO_PARAM]: returnPath })}`;
}

export function pathWithSearch({ pathname, search }: Pick<Location, "pathname" | "search">): string {
  return `${pathname}${search}`;
}

export function signInPathFor(returnPath: string): string {
  return returnPath === APP_PATHS.inventory ? APP_PATHS.auth : withReturnTo(APP_PATHS.auth, returnPath);
}

type Navigate = (path: string) => void;

function replaceInApp(path: string): void {
  navigate(path, { replace: true });
}

function requestedReturnPath(search: string): string | null {
  return safeReturnPath(new URLSearchParams(search).get(RETURN_TO_PARAM));
}

export function isReturnRequested(search: string = window.location.search): boolean {
  return requestedReturnPath(search) != null;
}

export function returnToSourceIfRequested(search: string = window.location.search, go: Navigate = replaceInApp): boolean {
  const path = requestedReturnPath(search);
  if (!path) return false;
  go(path);
  return true;
}
